import React from 'react';

export default function PageHero({
  eyebrow,
  title,
  subtitle,
  actions,
  children,
  image,
  imageAlt = '',
  className = ''
}) {
  return (
    <section className={`ps-hero ${image || children ? 'ps-hero-with-media' : ''} ${className}`.trim()}>
      <div className="ps-hero-inner">
        <div className="ps-hero-copy">
          {eyebrow && <div className="ps-hero-eyebrow">{eyebrow}</div>}
          <h1 className="ps-hero-title">{title}</h1>
          {subtitle && <p className="ps-hero-subtitle">{subtitle}</p>}
          {actions && <div className="ps-hero-actions">{actions}</div>}
        </div>
        {(image || children) && (
          <div className="ps-hero-media">
            {image && <img src={image} alt={imageAlt} />}
            {children}
          </div>
        )}
      </div>
    </section>
  );
}
